export default __webpack_public_path__ + "static/media/hero.e86b3215.svg";